module.exports = __webpack_public_path__ + "img/108ne.8beef18f.svg";